"use client";

import { useEffect } from "react";

import { getAttribution } from "@/app/libs/attribution";

const REPORTED_KEY = "buw_attribution_reported";

/**
 * Remembers the utm_* params of the landing URL and reports one
 * `campaign_visit` per tagged landing, so campaigns can be counted even on
 * pages that have no other analytics event.
 */
const AttributionCapture = () => {
  useEffect(() => {
    try {
      const attribution = getAttribution();
      const tagged = new URLSearchParams(window.location.search).has("utm_source");
      if (!attribution || !tagged) return;
      if (sessionStorage.getItem(REPORTED_KEY) === attribution.at) return;
      sessionStorage.setItem(REPORTED_KEY, attribution.at ?? "");

      fetch("/api/track", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ type: "campaign_visit", attribution }),
        keepalive: true,
      }).catch(() => {
        // Silent fail to avoid affecting UX
      });
    } catch {
      // Silent fail to avoid affecting UX
    }
  }, []);

  return null;
};

export default AttributionCapture;
